export default __webpack_public_path__ + "static/media/report_anonymously.c3556f96.svg";